import * as React from "react"
import { useEffect } from "react"

import { BIChart } from "./@components"
import { BIChartData, BIFilters, BIIs3DTable, BIIsLoadingChart, BIShowByPrice, BIShowChartLegend } from './@signals'
import { xAxisTitle } from './@services/grouping'
import { validateFormat } from "@utils"
import { AppCardTitle } from "@components"


export default function BIChartContent() {

	useEffect(() => {
		BIIsLoadingChart.value = true
		setTimeout(() => {
			BIIsLoadingChart.value = false
		}, 100)
	}, [BIShowChartLegend.value])

	if (!BIChartData.value.chartData || BIIs3DTable.value) return null

	return <BIChart
		// the columns of the query shown (its server echo), never the form being edited (CU-869fmk5ge)
		xTitle={xAxisTitle(BIFilters.value?.reportType, BIFilters.value?.groupBy)}
		isDateAxis={BIChartData.value.xlist?.every(d => validateFormat("yyyyMMdd", d))}
		titleChart={<AppCardTitle icon="chart-line" title="Chart"/>}
		dataChart={BIChartData.value.chartData[BIShowByPrice.value]}
		seriesToApply={BIChartData.value.keySeries.map(element => ({ ...element, disable: element?.is_previous_period_color }))}
	/>
}